import Vue from 'vue'
import InitUMeng from 'spt-umeng'
let initUMeng=new InitUMeng()
initUMeng.setUmId('66cd3fa2cac2a664de9a69fb')
Vue.prototype.$initUMeng = initUMeng
